import {
  getTableData,
  updateDetail,
  getDetail,
  getCountryList,
  updateInci,
  findInciFilter
} from '@/axios/api/inciManagement'

const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_COUNTRY_LIST = 'UPDATE_COUNTRY_LIST'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_DETAIL_LOADING = 'UPDATE_DETAIL_LOADING'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const CLEAR_PARMS = 'CLEAR_PARMS'

function initParams () {
  return {
    id: undefined,
    inciName: undefined,
    inciNameDisplayed: undefined,
    qdNameJp: undefined,
    cas: undefined,
    releaseCountryIds: undefined,
    functionClaimIds: undefined,
    bMark: undefined,
    functionIds: undefined,
    functionIdsManual: undefined,
    functionClaimIdsManual: undefined,
    showQdName: undefined
  }
}

const state = {
  tableData: [],
  tblLoading: false,
  detailLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: initParams(),
  detail: {},
  countryList: []
}

const getters = {
  tableData: state => state.tableData,
  pager: state => state.pager,
  params: state => state.params,
  tblLoading: state => state.tblLoading,
  detailLoading: state => state.detailLoading,
  detail: state => state.detail,
  countryList: state => state.countryList
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = { ...state.pager, ...pager }
  },
  [UPDATE_PARAMS] (state, params) {
    state.params = { ...state.params, ...params }
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_DETAIL_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [CLEAR_PARMS] (state) {
    state.params = initParams()
  },
  [UPDATE_COUNTRY_LIST] (state, countryList) {
    state.countryList = countryList
  }
}

const actions = {
  async getTableDataApi ({commit}, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      const { data: res } = await getTableData(params)
      commit(UPDATE_TABLEDATA, res.records || [])
      commit(UPDATE_PAGER, { total: res.total })
    } catch (e) {
      commit(UPDATE_TABLEDATA, [])
    }
    commit(UPDATE_TBL_LOADING, false)
  },
  setPagerApi ({commit}, params) {
    commit(UPDATE_PAGER, params)
  },
  setParamsApi ({commit}, params) {
    commit(UPDATE_PARAMS, params)
  },
  clearParamsApi ({ commit }) {
    commit(CLEAR_PARMS)
  },
  async updateDetailApi ({ commit }, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const res = await updateDetail(params)
      commit(UPDATE_DETAIL_LOADING, false)
      return res
    } catch (e) {}
    commit(UPDATE_DETAIL_LOADING, false)
  },
  // 获取详情
  async getDetailApi ({ commit }, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const { data: res } = await getDetail(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
    commit(UPDATE_DETAIL_LOADING, false)
  },
  async getCountryListApi ({commit}, params) {
    try {
      const { data: res } = await getCountryList(params)
      commit(UPDATE_COUNTRY_LIST, res)
    } catch (e) {}
  },
  async updateInciApi ({commit}, params) {
    try {
      await updateInci(params)
      return true
    } catch (e) {
      return false
    }
  },
  async findInciFilterApi ({commit}, params) {
    try {
      const res = await findInciFilter(params)
      return res
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/inciManagement.js